/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Air_Handler_Unit_Exceptional_Planning_Range_ErrorInputs */



/**
* | output |
* | --- |
* | "The end must be after the start." |
*
* @param {Air_Handler_Unit_Exceptional_Planning_Range_ErrorInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const air_handler_unit_exceptional_planning_range_error = /** @type {((inputs?: Air_Handler_Unit_Exceptional_Planning_Range_ErrorInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Air_Handler_Unit_Exceptional_Planning_Range_ErrorInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("The end must be after the start.")
	return /** @type {LocalizedString} */ ("La fin doit être postérieure au début.")
});